import { useEffect, useMemo, useState } from 'react';
import { protectedUrl } from '../../service/request';

const SafeImage = ({
  src,
  alt = '',
  className,
  style,
  width,
  height,
  loading = 'lazy',
  decoding = 'async',
  draggable = false,
  onClick,
  role,
  tabIndex,
  onKeyDown,
  fallback = null,
} = {}) => {
  const [errored, setErrored] = useState(false);
  const [retryKey, setRetryKey] = useState(0);
  useEffect(() => {
    setRetryKey(0);
    setErrored(false);
  }, [src]);
  const resolved = useMemo(() => {
    try {
      if (!src) return null;
      const base = protectedUrl(src);
      if (!retryKey) return base;
      return `${base}${base.includes('?') ? '&' : '?'}r=${retryKey}`;
    } catch {
      return src;
    }
  }, [src, retryKey]);

  if (errored || !resolved) {
    if (fallback) return fallback;

    return (
      <div
        className={className}
        style={{ background: '#f2f4f7', ...style, width, height }}
        aria-hidden
        role={role}
        tabIndex={tabIndex}
        onClick={onClick}
        onKeyDown={onKeyDown}
      />
    );
  }

  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      style={{ ...style, width, height }}
      loading={loading}
      decoding={decoding}
      draggable={draggable}
      onError={() => {
        if (!retryKey) {
          setRetryKey(Date.now());
          return;
        }
        setErrored(true);
      }}
      onClick={onClick}
      role={role}
      tabIndex={tabIndex}
      onKeyDown={onKeyDown}
    />
  );
};

export default SafeImage;
